import React from "react";
const noEvents = require("./images/dark-no-imgs.svg");
const gssNewLoader = require("../../../public/images/website/photographer/gss-loader.gif");
import { Event } from "./useFilteredEvents";

const EventsList = ({
  events,
  loading
}: {
  events: Event[];
  loading: boolean;
}) => {
  const renderEvent = (event: Event) => (
    <a
      href={event.browsePhotosPath}
      target="_blank"
      key={event.id}
      className="ev__single bg-lt-green flex-row"
    >
      <span className="ev__date completed-ev-date-badge">
        <span className="completed-ev-date-p1">
          {event.startDate.split("-")[0]}
        </span>
        <span className="completed-ev-date-p2">
          {event.startDate.split("-")[1]}
        </span>
        <span className="completed-ev-date-p3">
          {event.startDate.split("-")[2]}
        </span>
      </span>
      <span className="ev__text">
        <span className="ev__title">{event.name}</span>
        <span className="ev__location">{event.location}</span>
      </span>

      {event.logo.logo && event.logo.logo.small.url && event.logo.logo.url && (
        <img
          srcSet={`${event.logo.logo.small.url}, ${event.logo.logo.url} 2x`}
          src={event.logo.logo.url}
          className="ev__logo"
          alt=""
        />
      )}
    </a>
  );

  return (
    <section className="s-results date-results ns ev">
      <div className="container">
        {loading ? (
          <div className="gss-loader">
            <img src={gssNewLoader} />
          </div>
        ) : (
          events.length === 0 && (
            <div className="no-results events text-center">
              <img src={noEvents} alt="" />
              <h6>No events found</h6>
            </div>
          )
        )}
        {events.map(event => renderEvent(event))}
      </div>
    </section>
  );
};
export default EventsList;
